module.exports = __webpack_public_path__ + "img/icon-enkrypt-colored.d47ef2e7.svg";